import API from './axios.js';

export const getAddedCases = (limit = 10) =>API.get(`case/manual?`, {params: { limit }});
export const getAddedCasesCourtRef = (courtref) =>API.get(`/case/manual/by-court-ref/${courtref}`);